import React, { useState, useEffect } from "react";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import axios from "axios";
import { ModalSaldoInicial } from "./modalCargarSaldosIniciales";
import { SearchInput } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";

function TablaSaldoInicial(props) {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const headCells = [
    {
      id: "",
      label: "CÓDIGO",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "DESCRIPCION",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "ID",
      width: "100px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "OPCIONES",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [permiso] = useState();
  const [records, setRecords] = useState([]);
  const [cuenta, setCuenta] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [valorFiscal, setValorFiscal] = useState();

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.idcuentacontable.includes(target.value) === null
                ? ""
                : x.idcuentacontable.includes(target.value)) ||
              (x.codigocuenta === null
                ? ""
                : x.codigocuenta
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.descripcion === null
                ? ""
                : x.descripcion
                    .toLowerCase()
                    .includes(target.value.toLowerCase())) ||
              (x.idplancuenta.includes(target.value) === null
                ? ""
                : x.idplancuenta.includes(target.value))
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint =
      op.conexion +
      `/api/contabilidadfis/allcuentascontables?idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setRecords(response.data);
          console.log(response.data);
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  const seleccionarRegistro = (id) => {
    let endpoint = `${op.conexion}/api/contabilidadfis/selectcuentascontables?idefiscal=${idefiscal}&id=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          console.log(response.data);
          setCuenta(response.data);
          setMostrar5(true);
        }
        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarRegistros();
  }, []);

  const consultarValor = (ope, id) => (event) => {
    event.preventDefault();
    setOperacion(ope);
    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
      console.log("1");
    } else {
      seleccionarRegistro(id);
    }
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);

    blanquearCampos();
  };

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setOperacion(0);
    setValorFiscal();
  };

  const exitHandler = (e) => {
    e.preventDefault();

    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light rounded-top">
          <h3 className="fw-bold m-0">Gestion de Saldo Inicial</h3>
          <a href="#" onClick={exitHandler} className="text-light fw-bold">
            Salir <i className="fas fa-times ms-2"></i>
          </a>
      </header>
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <SearchInput 
            placeholder="Buscar"
            onChange={handleSearch}
          />
        </div>
        <div className="col-auto m-0 p-0">
          <PrimaryButton icon = 'fa-plus m-0'
            onClick={consultarValor(1, "")}
            disabled={permiso && permiso.substring(1, 2) !== "1"}
          >
          </PrimaryButton>
        </div>
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer>
          <TblHead />

          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr
                  key={item.idcuentacontable}
                  style={{ padding: "0" }}
                >
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",

                      width: "10px",
                    }}
                  >
                    {item.codigocuenta ? item.codigocuenta.trim() : ""}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "left",

                      width: "80px",
                    }}
                  >
                    {item.descripcion ? item.descripcion.trim() : ""}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",

                      width: "80px",
                    }}
                  >
                    {item.idplancuenta}
                  </td>

                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",

                      width: "80px",
                    }}
                  >
                    <button
                      onClick={consultarValor(4, item.idcuentacontable)}
                      className="rounded-circle btn btn-sm btn-info"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarValor(2, item.idcuentacontable)}
                      className="rounded-circle btn btn-sm btn-warning"
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={consultarValor(3, item.idcuentacontable)}
                      className="rounded-circle btn btn-sm btn-danger"
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalSaldoInicial
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
        cuenta={cuenta}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaSaldoInicial;
